function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { DriverType, storageFactory } from '@domain-group/fe-helper';
var storage = storageFactory({
  name: 'allhomes-api',
  driver: DriverType.LOCALSTORAGE
});
var LOGGING_KEY = 'logging';
var noop = () => {};
var noopLogger = {
  debug: noop,
  log: noop,
  info: noop,
  warn: noop,
  error: noop
};
var defaultLevel = 'none';
var ROOT = '_root';
var componentStyle = 'font-weight:bold;color:darkred';
var packageStyle = 'font-weight:bold;color:black';
var separatorStyle = 'font-weight:normal;color:gray';
var buildLogger = function buildLogger(level, pkg) {
  var components = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var actualLevel = level !== null && level !== void 0 ? level : defaultLevel;
  if (actualLevel === 'none') {
    return noopLogger;
  }
  var wrappedLogger = func => function (message) {
    var prefix = (pkg ? [pkg, ...components] : components).join('%c#%c');
    var extraArgs = prefix ? [packageStyle, components.map(() => [separatorStyle, componentStyle]), ''].flat(2) : [];
    for (var _len = arguments.length, optionalParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      optionalParams[_key - 1] = arguments[_key];
    }
    func("".concat(prefix ? "%c".concat(prefix, "%c: ") : '').concat(message), ...[...extraArgs, ...optionalParams]);
  };
  var debug = actualLevel === 'debug' ? wrappedLogger(console.debug) : noop;
  var info = ['info', 'debug'].includes(actualLevel) ? wrappedLogger(console.info) : noop;
  var warn = actualLevel === 'error' ? noop : wrappedLogger(console.warn);
  var error = wrappedLogger(console.error);
  return {
    debug,
    info,
    log: info,
    warn,
    error
  };
};
var loggers = {};
export default (_ref => {
  var logLevels = _ref.logLevels;
  var levels = _objectSpread(_objectSpread({
    [ROOT]: defaultLevel
  }, logLevels), storage.getItem(LOGGING_KEY));
  var findLevel = (pkg, components) => {
    var loggerName = [pkg, ...components].join('#');
    if (loggerName in loggers) {
      var _levels$loggerName;
      return (_levels$loggerName = levels[loggerName]) !== null && _levels$loggerName !== void 0 ? _levels$loggerName : null;
    }
    if (components.length) {
      return findLevel(pkg, components.slice(0, -1));
    }
    return null;
  };
  var getLogger = function getLogger() {
    var _findLevel;
    var loggerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ROOT;
    var _loggerName$split = loggerName.split('#'),
      _loggerName$split2 = _toArray(_loggerName$split),
      pkg = _loggerName$split2[0],
      components = _loggerName$split2.slice(1);
    var level = (_findLevel = findLevel(pkg, components)) !== null && _findLevel !== void 0 ? _findLevel : levels[ROOT];
    if (loggerName in loggers) {
      return loggers[loggerName];
    }
    var logger = buildLogger(level, pkg === ROOT ? undefined : pkg, components);
    loggers[loggerName] = logger;
    return logger;
  };
  return {
    getLogger
  };
});